export default __webpack_public_path__ + "static/media/goal-investment-illustration.ecd9a8fd.svg";